module.exports = __webpack_public_path__ + "static/media/section-5-bg.31489a6f.svg";